// 销售相关数据模块（渠道销售、销售大类、销售排行）
const state = {
  // 渠道销售占比数据
  channelSales: {
    period: 'today',
    channels: []
  },
  // 销售大类占比数据
  salesCategory: {
    period: 'today',
    categories: [
      { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
      { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
      { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
    ]
  },
  // 单品种销售排行
  salesRanking: {
    period: 'week',
    rows: []
  }
}

const mutations = {
  // 设置渠道销售数据
  SET_CHANNEL_SALES(state, data) {
    state.channelSales = data
  },
  // 设置销售大类数据
  SET_SALES_CATEGORY(state, data) {
    state.salesCategory = data
  },
  // 设置单品种销售排行
  SET_SALES_RANKING(state, data) {
    state.salesRanking = data
  },
  // 重置销售数据
  RESET_SALES(state) {
    state.channelSales = {
      period: 'today',
      channels: []
    }
    state.salesCategory = {
      period: 'today',
      categories: [
        { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
        { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
        { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
      ]
    }
    state.salesRanking = {
      period: 'week',
      rows: []
    }
  }
}

const actions = {
  // 获取渠道销售数据（支持静默刷新）
  async fetchChannelSales({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.channelSales.period || 'today'
      
      // 优先从大屏完整数据中派生渠道占比
      const mapPeriodKey = {
        today: { xianxia: 'qudaozhanbi_xianxia_day', ziying: 'qudaozhanbi_ziying_day', pixiao: 'qudaozhanbi_pixiao_day', pixiao_xx: 'qudaozhanbi_pixiao_xx_day' },
        week:  { xianxia: 'qudaozhanbi_xianxia_week', ziying: 'qudaozhanbi_ziying_week', pixiao: 'qudaozhanbi_pixiao_week', pixiao_xx: 'qudaozhanbi_pixiao_xx_week' },
        month: { xianxia: 'qudaozhanbi_xianxia_month', ziying: 'qudaozhanbi_ziying_month', pixiao: 'qudaozhanbi_pixiao_month', pixiao_xx: 'qudaozhanbi_pixiao_xx_month' }
      }
      const keys = mapPeriodKey[currentPeriod] || mapPeriodKey.today
      const bigData = rootState.screen.screenData || {}
      // 先将原始值标准化为数值
      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }
      const hasBigDataForPeriod = bigData && (bigData[keys.xianxia] !== undefined || bigData[keys.ziying] !== undefined || bigData[keys.pixiao] !== undefined || bigData[keys.pixiao_xx] !== undefined)

      if (hasBigDataForPeriod) {
        // 原始数值（可能为金额/数量），第三方默认 0
        const offlineVal = safeNum(bigData[keys.xianxia])
        const selfOpVal = safeNum(bigData[keys.ziying])
        const thirdVal = safeNum(bigData[keys.pixiao])
        const batchVal = safeNum(bigData[keys.pixiao_xx]) // 新增线下批销数据
        const total = offlineVal + selfOpVal + thirdVal + batchVal
        const toPercent = (val, sum) => sum > 0 ? Number(((val / sum) * 100).toFixed(2)) : 0
        const channels = [
          { channelName: '线下零售', percentage: toPercent(offlineVal, total) },
          { channelName: '自营平台', percentage: toPercent(selfOpVal, total) },
          { channelName: '第三方线上', percentage: toPercent(thirdVal, total) },
          { channelName: '线下批销', percentage: toPercent(batchVal, total) }
        ]
        commit('SET_CHANNEL_SALES', { period: currentPeriod, channels })
      } else {
        // 回退至原有渠道销售接口
        const respData = {
          period: 'today',
          channels: [
            { channelName: '线下零售', percentage: 0 },
            { channelName: '自营平台', percentage: 0 },
            { channelName: '第三方线上', percentage: 0 },
            { channelName: '线下批销', percentage: 0 }
          ]
        }
        commit('SET_CHANNEL_SALES', { ...respData, period: currentPeriod })
      }
    } catch (error) {
      console.error('获取渠道销售数据失败:', error)
    }
  },
  // 获取单品种销售排行（支持静默刷新，使用大屏数据 danpin_xiaoshou_* 映射为表格行）
  async fetchSalesRanking({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.salesRanking.period || 'week'
      
      const mapPeriodKey = {
        week: 'danpin_xiaoshou_week',
        month: 'danpin_xiaoshou_month',
        halfyear: 'danpin_xiaoshou_halfyear'
      }
      const key = mapPeriodKey[currentPeriod] || mapPeriodKey.week
      const bigData = rootState.screen.screenData || {}
      let list = bigData[key]

      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }
      const formatPrice = (v) => {
        const n = safeNum(v)
        return n.toFixed(2)
      }
      const formatInt = (v) => {
        const n = safeNum(v)
        return String(Math.round(n))
      }

      if (!Array.isArray(list)) {
        list = list && typeof list === 'object' ? [list] : []
      }

      const rows = list.map((item, idx) => {
        const rank = idx + 1
        const rankHtml = rank <= 3
          ? `<span class=\"rank_card top3\">NO.${rank}</span>`
          : `<span class=\"rank_card\">NO.${rank}</span>`
        const name = String(item?.pm || item?.name || '')
        const price = formatPrice(item?.dj)
        const amount = formatPrice(item?.my)
        const qty = formatInt(item?.sl)
        return [rankHtml, name, price, amount, qty]
      })

      commit('SET_SALES_RANKING', { period: currentPeriod, rows })
    } catch (error) {
      console.error('获取单品种销售排行数据失败:', error)
      commit('SET_SALES_RANKING', { period: currentPeriod, rows: [] })
    }
  },
  // 获取销售大类数据（支持静默刷新，优先使用大屏数据 xiaoshou_dalei_zhanbi_*，缺失时回退到原 API）
  async fetchSalesCategory({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.salesCategory.period || 'today'
      
      const mapPeriodKey = {
        today: 'xiaoshou_dalei_zhanbi_day',
        week: 'xiaoshou_dalei_zhanbi_week',
        month: 'xiaoshou_dalei_zhanbi_month'
      }
      const key = mapPeriodKey[currentPeriod] || mapPeriodKey.today
      const bigData = rootState.screen.screenData || {}
      const dalei = bigData[key]

      // 若大屏数据存在，则根据 dl 映射到 图书/多元/联营 三类，缺失默认 0，并计算百分比
      if (dalei && (Array.isArray(dalei) || typeof dalei === 'object')) {
        const safeNum = (v) => {
          const n = Number(v)
          return isNaN(n) ? 0 : n
        }

        const categories = [
          { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
          { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
          { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
        ]

        const idxMap = { '图书': 0, '多元': 1, '联营': 2 }

        // 处理数组形式的数据
        if (Array.isArray(dalei)) {
          dalei.forEach(item => {
            if (item && typeof item === 'object') {
              const name = item.dl || ''
              const value = safeNum(item.my)
              const idx = idxMap[name]
              if (idx !== undefined) {
                categories[idx].salesAmount = value
              }
            }
          })
        } else {
          // 处理单个对象形式的数据（保持向后兼容）
          const name = dalei.dl || ''
          const value = safeNum(dalei.my)
          const idx = idxMap[name]
          if (idx !== undefined) {
            categories[idx].salesAmount = value
          }
        }

        const total = categories.reduce((sum, c) => sum + safeNum(c.salesAmount), 0)
        categories.forEach((c) => {
          c.percentage = total > 0 ? Number(((safeNum(c.salesAmount) / total) * 100).toFixed(2)) : 0
        })

        commit('SET_SALES_CATEGORY', { period: currentPeriod, categories })
        return
      }

      // 回退到原 API
      const respData = {
        period: 'today',
        categories: [
          { categoryId: '1', categoryName: '图书', salesAmount: 0, percentage: 0 },
          { categoryId: '2', categoryName: '多元', salesAmount: 0, percentage: 0 },
          { categoryId: '3', categoryName: '联营', salesAmount: 0, percentage: 0 }
        ]
      }
      commit('SET_SALES_CATEGORY', { ...respData, period: currentPeriod })
    } catch (error) {
      console.error('获取销售大类数据失败:', error)
    }
  }
}

const getters = {
  currentChannelPeriod: state => state.channelSales.period,
  currentCategoryPeriod: state => state.salesCategory.period,
  isDataLoaded: state => {
    return state.channelSales.channels.length > 0 &&
           state.salesCategory.categories.length > 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
